import { Autocomplete, TextField } from "@mui/material";

const options = ["USD", "IQD"];

const SelectCurrency = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Currency"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectCurrency;
